module.exports = __webpack_public_path__ + "media/images/icons/move-2633c989d57c90ffbc3b4b54c9631b02.svg";